import { Modal } from "antd";
import { SignalContext } from "context/SignalContext";
import Cookies from "js-cookie";
import { StreamingCameraType } from "lib/types";
import { useCommonService } from "pages/service";
import { useContext, useEffect, useRef, useState } from "react";
import { showToast } from "ui/components/common";
import usePresetRtcService from "ui/preset/service";
import CameraPlayer from "ui/streaming/camera-player";
import { STREAM_TYPE_LIVE } from "webrtc-player/common/base";
let key = 0;
export default function EditPresetModal({
  visible,
  camera,
  onClose,
  onPresetUpdated,
  presetList,
}) {
  const { getCredentials } = useCommonService();
  const { setPreset } = usePresetRtcService();
  const token = Cookies.get("token");
  const { sessionId } = useContext(SignalContext);
  const [streamingCamera, setStreamingCamera] = useState(null);
  const cameraPlayerRef = useRef(null);
  useEffect(() => {
    if (!visible) return;
    const handler = setTimeout(
      () => {
        setStreamingCamera(null);
        cameraPlayerRef.current?.closeStreaming();
        onClose?.();
      },
      1000 * 3 * 60,
    );
    return () => {
      clearTimeout(handler);
    };
  }, [visible]);
  useEffect(() => {
    if (!camera || !visible) return;
    getCredentials([camera.nvrId], camera.orgId).then(
      ([objCredentialFound]) => {
        const _streamingCamera: StreamingCameraType = {
          orgId: camera.orgId,
          nvrId: camera.nvrId,
          devId: camera.devId,
          cameraId: camera.id,
          cameraName: camera.name,
          token: token!,
          turn: objCredentialFound?.turn,
          rtcToken: objCredentialFound?.token,
          sessionId: sessionId,
          cameraMac: camera.macAddress,
          remoteIndex: camera.remoteIndex,
          streamId: "0",
          status: camera.status,
          siteId: camera.siteId,
          siteName: camera.siteName,
          capabilities: camera.capabilities,
          type: camera.type,
          videoInfo: {
            width: camera.mainStream?.resolution.width,
            height: camera.mainStream?.resolution.height,
            fps: camera.mainStream?.frameRate,
          },
        };
        key++;
        setStreamingCamera(_streamingCamera);
      },
    );
  }, [camera, visible]);
  function getEmptyPresetIndex(presetList) {
    for (let i = 1; i <= 255; i++) {
      const match = presetList?.find((preset) => preset.id === i);
      if (!match) return i;
    }
  }
  async function onPresetSave() {
    const emptyIndex = getEmptyPresetIndex(presetList);
    await setPreset(
      +camera.orgId,
      +camera.nvrId,
      camera?.devId,
      camera,
      emptyIndex,
      `Preset ${emptyIndex}`,
    );
    showToast(0, "Preset created successfully");
    onPresetUpdated(emptyIndex);
  }
  return (
    <>
      <Modal
        title={`Create Preset: Preset ${getEmptyPresetIndex(presetList)}`}
        open={visible}
        onCancel={() => {
          setStreamingCamera(null);
          cameraPlayerRef.current?.closeStreaming();
          onClose?.();
        }}
        width={1000}
        height={1000}
        okButtonProps={{ className: "primaryButton", onClick: onPresetSave }}
        cancelButtonProps={{ className: "primaryButton bordered" }}
        closable={false}
      >
        {streamingCamera && (
          <CameraPlayer
            ref={cameraPlayerRef}
            key={key}
            showPtz={true}
            muted={false}
            selected={false}
            streamingCamera={streamingCamera}
            streamType={STREAM_TYPE_LIVE}
            visible={visible}
          />
        )}
      </Modal>
    </>
  );
}
